import {
  RecommendPanel,
  RecommendTypes,
  Result,
} from '@doda/common/src/interfaces/api/recommendPanel';
import { useAppDispatch } from 'redux/hooks';
import { KeywordsResultResponse } from '@doda/api-client/aspida/@types';
import {
  measureSimilarKeywordFavorite,
  measureSimilarKeywordJob,
} from 'pages/DodaFront/View/JobSearchList/logics/analytics';
import {
  measureClickRecommendCardBookmark,
  measureClickRecommendCardText,
  measureClickRecommendCardThumbnail,
} from '../../logics/analytics';

interface Argument {
  recommendForList: RecommendPanel | null;
  recommendForSlider: RecommendPanel | null;
  similarKeywordList: KeywordsResultResponse[];
}

/**
 * レコメンドカード関連計測処理
 * @param param.recommendForList レコメンドグリッドのデータ
 * @param param.recommendForSlider レコメンドスライダーのデータ
 * @param param.similarKeywordList 類似キーワードリスト
 * @returns レコメンドカード内パーツ押下時の計測
 */
export const useRecommendListAnalytics = ({
  recommendForList,
  recommendForSlider,
  similarKeywordList,
}: Argument) => {
  const dispatch = useAppDispatch();

  // カード押下時の計測（画像、テキスト押下時に実行する）
  const onClickRecommendCard = (jid: string | undefined) => {
    if (recommendForList) {
      const similarKeywords = similarKeywordList.find(
        (item) => item.jid === jid
      )?.keywordList;
      const existSimilarKeywords = !!similarKeywords?.length;
      dispatch(measureSimilarKeywordJob(existSimilarKeywords));
    }
    if (recommendForSlider) {
      const similarKeywords = similarKeywordList.find(
        (item) => item.jid === jid
      )?.keywordList;
      const existSimilarKeywords = !!similarKeywords?.length;
      dispatch(measureSimilarKeywordJob(existSimilarKeywords));
    }
  };

  // 画像押下時の計測
  const onClickRecommendCardThumbnail = (
    index: number,
    jid: string | undefined,
    recommendType: RecommendTypes,
    effectName: string
  ) => {
    dispatch(
      measureClickRecommendCardThumbnail(index, recommendType, effectName)
    );
    onClickRecommendCard(jid);
  };

  // テキスト押下時の計測
  const onClickRecommendCardText = (
    index: number,
    jid: string | undefined,
    recommendType: RecommendTypes,
    effectName: string
  ) => {
    dispatch(measureClickRecommendCardText(index, recommendType, effectName));
    onClickRecommendCard(jid);
  };

  // 気になる押下時の計測
  const onClickBookmark = (
    recommendResult: Result,
    index: number,
    jid: string | undefined
  ) => {
    dispatch(measureClickRecommendCardBookmark(recommendResult.itemNo, index));
    const similarKeywords = similarKeywordList.find(
      (item) => item.jid === jid
    )?.keywordList;
    const existSimilarKeywords = !!similarKeywords?.length;
    dispatch(measureSimilarKeywordFavorite(existSimilarKeywords));
  };

  return {
    onClickRecommendCardThumbnail,
    onClickRecommendCardText,
    onClickBookmark,
  };
};
